import { render, staticRenderFns } from "./Ipsetting.vue?vue&type=template&id=ae8fd558&"
import script from "./Ipsetting.vue?vue&type=script&lang=js&"
export * from "./Ipsetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports